<template>
    <el-image :src="src" :fit="fit" :alt="alt">
        <img slot="error" src="@/assets/default.png" fit="contain" width="100%"/>
    </el-image>
</template>

<script>
    export default {
        name: "CustomImage",
        props: {
            src: {
                type: String,
                default: null,
            },
            fit: {
                type: String,
                default: 'contain',
            },
            alt: String,

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/others/CustomImage.vue